/**
 * 相亲角档位请求接口
 * @author 王振宇
 * @since 2022-11-17
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_ANGLEOFAFFINITYPOSITION_PAGE_LIST: function GET_ANGLEOFAFFINITYPOSITION_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityPosition/getPageList',
        method: 'post',
        data: data
      });
    },
    GET_ANGLEOFAFFINITYPOSITION_LIST: function GET_ANGLEOFAFFINITYPOSITION_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityPosition/getList',
        method: 'get',
        params: data
      });
    },
    GET_ANGLEOFAFFINITYPOSITION_INFO: function GET_ANGLEOFAFFINITYPOSITION_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityPosition/info',
        method: 'get',
        params: data
      });
    },
    SAVE_ANGLEOFAFFINITYPOSITION: function SAVE_ANGLEOFAFFINITYPOSITION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityPosition/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_ANGLEOFAFFINITYPOSITION: function UPDATE_ANGLEOFAFFINITYPOSITION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityPosition/update',
        method: 'put',
        data: data
      });
    },
    DELETE_ANGLEOFAFFINITYPOSITION: function DELETE_ANGLEOFAFFINITYPOSITION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityPosition/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_ANGLEOFAFFINITYPOSITION: function DELETE_BATCH_ANGLEOFAFFINITYPOSITION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/angleOfAffinityPosition/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});